<!--
 * @Author: your name
 * @Date: 2021-08-09 20:30:58
 * @LastEditTime: 2021-08-13 20:24:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /b_c_i18n/src/components/OrderProgress/progressItme.vue
-->
<template>
  <div class="progress-itme">
    <div class="progress-left">
      <div :class="statusClassName"></div>
      <div class="line" v-if="!lastIndex"></div>
    </div>
    <div class="progress-right">
      <div class="progress-status__desc ellipsis" :class="colorClassName">
        {{ listInfo.statusDesc }}
      </div>
      <div class="progress-status__time ellipsis" :class="colorClassName">
        {{ listInfo.statusTime }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    listInfo: Object,
    lastIndex: Boolean,
  },
  computed: {
    statusClassName() {
      return this.listInfo?.highLight ? 'status-active' : 'status';
    },
    colorClassName() {
      return this.listInfo?.highLight ? '' : 'color-active';
    },
  },
};
</script>
<style lang="scss" scoped>
.progress-itme {
  padding: 0 24px;
  display: flex;
}
.progress-right {
  width: 80%;
}
.progress-left {
  width: 12px;
  margin-right: 12px;
  padding-top: 4px;
}
.status {
  width: 8px;
  height: 8px;
  background: #e6e6e6;
  border-radius: 50%;
  margin: 0 auto;
}
.status-active {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #05b26c;
  margin: 0 auto;
}
.line {
  width: 2px;
  height: 48px;
  background: #e6e6e6;
  border-radius: 4px;
  margin: 6px auto;
}

.progress-status__desc {
  font-family: 'Aspira Medium';
  font-size: 18px;
  color: #000000;
  font-weight: 500;
  margin-bottom: 8px;
}
.progress-status__time {
  font-family: 'Aspira Light';
  font-size: 16px;
  color: #000000;
  font-weight: 200;
}
.color-active {
  font-family: 'Aspira Light';
  color: #999999;
  font-weight: 200;
  font-size: 16px;
}
@media screen and (max-width: 768px) {
  .progress-itme {
    padding: rem(0) rem(36);
  }
.progress-left {
  width: rem(24);
  margin-right: rem(24);
  padding-top: rem(8);
}
.status {
  width: rem(16);
  height: rem(16);
}
.status-active {
  width: rem(24);
  height:  rem(24);
}
.line {
  width: rem(4);
  height: rem(96);
  border-radius: rem(8);
  margin: rem(12) auto;
}

.progress-status__desc {
  font-size: rem(36);
  margin-bottom: rem(16);
}
.progress-status__time {
  font-size: rem(32);
}
.color-active {
 font-size: rem(32);
}
}
</style>
